<template>
    <div class="mandate-conformity-banner">
        <img src="/ressources/logged/img/illustrations/settings-warning.svg" alt="" />
        <div class="mandate-conformity-banner__content">
            <h2 class="mandate-conformity-banner__title typographies-paragraph-large-bold">
                {{ title }}
            </h2>
            <div
                class="mandate-conformity-banner__description typographies-paragraph-medium-regular"
            >
                {{ description }}
            </div>
        </div>
        <CompassButton
            v-if="hasAction"
            v-bind="actionProps"
            class="mandate-conformity-banner__action"
            type="tertiary-contrast"
            @click="actionEvent"
        />
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import Feature from 'Services/Feature';
const { mapActions: popupPanelMapActions } = createNamespacedHelpers('popupPanel');

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        title() {
            switch (this.type) {
                case 'company_information':
                    return this.$t.__('MandateConformityBanner.companyInformation.title');
                case 'taxes':
                    return this.$t.__('MandateConformityBanner.taxes.title');
                case 'units':
                    return this.$t.__('MandateConformityBanner.units.title');
                default:
                    return '';
            }
        },
        description() {
            switch (this.type) {
                case 'company_information':
                    return this.$t.__('MandateConformityBanner.companyInformation.description');
                case 'taxes':
                    return this.$t.__('MandateConformityBanner.taxes.description');
                case 'units':
                    return this.$t.__('MandateConformityBanner.units.description');
                default:
                    return '';
            }
        },
        hasAction() {
            return ['taxes', 'units'].includes(this.type);
        },
        actionProps() {
            switch (this.type) {
                case 'taxes':
                    return {
                        label: this.$t.__('MandateConformityBanner.taxes.button'),
                        leftIcon: 'warning-fill',
                    };
                case 'units':
                    return {
                        label: this.$t.__('MandateConformityBanner.units.button'),
                        leftIcon: 'warning-fill',
                    };
                default:
                    return '';
            }
        },
        actionEvent() {
            switch (this.type) {
                case 'taxes':
                    return this.handleTaxesAction;
                case 'units':
                    return this.handleContactSupport;
                default:
                    return null;
            }
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        handleTaxesAction() {
            this.open({
                key: 'vatCheckDialog',
                props: {
                    languages: this.languages,
                    taxes: this.listNoEcoTaxes,
                },
            });
        },
        handleContactSupport() {
            if (Feature.isEnabled('intercom')) {
                window.Intercom('show');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.mandate-conformity-banner {
    align-items: center;
    background: linear-gradient(90deg, #2645c6 0%, #4868fd 75%);
    color: var(--colors-common-text-standard-on-color);
    display: flex;
    gap: var(--spacing-2);
    margin: -32px -24px var(--spacing-4);
    padding: var(--spacing-3) var(--spacing-4);

    &__title {
        margin: 0;
    }

    &__action {
        margin-left: auto;
    }
}
</style>
